<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
        <nav class="footer-nav">
          <ul>
            <li>
              <a
                href="https://www.focus.org"
                target="_blank"
                rel="noopener"
                class="main-site-link"
              >FOCUS Main Site</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
    name: 'MainFooter'
};
</script>
<style>
@media (max-width: 768px) {
  .main-site-link {
    display: none;
  }
}
</style>
